import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MobileSizeService {
  public isMobileSize = false;
  constructor() { }
}
